import React, { useEffect } from "react";
import Link from "next/link";
import AOS from "aos";
import "aos/dist/aos.css";
import Lottie from "react-lottie-player";
import Head from "next/head";
import Home from "../../json/Home.json";
import Image from "next/image";
import styles from "../../styles/Home.module.css";
import questions from "../../images/undraw_Online_test_re_kyfx.png";
import investment from "../../images/undraw_Success_factors_re_ce93.png";
import explore from "../../images/undraw_Progress_indicator_re_4o4n.png";
import decision from "../../images/undraw_Up_to_date_re_nqid.png";
import Footer from "../../component/footer";
import CallToAction from "../../component/callToAction";
import BuyingChanceFunnel from "./budget";
import BuyingChanceFunnels from "../../component/buying-funnel/funnels";

export default function BuyingChance() {
  useEffect(() => {
    AOS.init();
  }, []);
  return (
    <>
      <Head>
        <title>Discover Property Buying Chances with Our Calculator</title>
        <link
          rel="canonical"
          href="https://abodefinder.com.au/buying-chance/"
        ></link>
        <meta
          property="og:title"
          content="Discover Property Buying Chances with Our Calculator"
        />
        <meta
          property="og:description"
          content="Calculate your chances of buying the perfect property with our AI-powered Buying Chance Calculator. Get personalized insights based on your budget and selected suburbs."
        />
        <meta property="og:image" content="../images/1.png" />
        <meta
          property="og:url"
          content="https://abodefinder.com.au/buying-chance/"
        />
        <meta
          name="description"
          content="Calculate your chances of buying the perfect property with our AI-powered Buying Chance Calculator. Get personalized insights based on your budget and selected suburbs."
        />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <link rel="icon" type="image/png" sizes="32x32" href="https://abodefinder.com.au/blog-static/img/favicon-32.ico"/>
      </Head>
      <main className={styles.firstMainBuying}>
        <h1 className={styles.mainp}>
          Discover Your Buying Chance in Your Preferred Suburb with Buying
          Chance Calculator
        </h1>
        <h2 className={styles.mainp1}>
          Calculate Your Property Buying Chance with Ease
        </h2>
        <div className={styles.FuneelIndex}>
          <BuyingChanceFunnels />
        </div>
      </main>
      <section className={styles.calculator}>
        <article className={styles.textCalculator} data-aos="fade-up">
          <p>
            {" "}
            Buying Chance Calculator is a powerful tool designed to help you
            gain clear insights into your chances of buying a property in your
            preferred suburb. Whether you're a first-time buyer or a seasoned
            investor, our user-friendly platform makes it easy to assess your
            buying power and explore investment opportunities in your preferred
            suburb. Our advanced algorithms and data analysis provide you with a
            comprehensive report that includes clear insights into the property
            market, making it easy to make informed investment decisions. Trust
            Buying Chance Calculator as your ultimate partner in your property
            investment journey.
          </p>
        </article>
        <article className={styles.animCalculator}>
          <Lottie
            loop
            animationData={Home}
            play
            background="transparent"
            speed="1"
            className={styles.lottieHome}
          />
        </article>
      </section>
      <CallToAction />
      <section className={styles.buyingChanceWork}>
        <article className={styles.wealthText}>
          <h3 style={{ fontSize: "30px" }}>How is work?</h3>
          <p>
            Buying Chance Calculator is a user-friendly platform that makes it
            easy to calculate your chances of buying a property in your
            preferred suburb. Here's how it works
          </p>
        </article>
        <article className={styles.wealthFieldsRow}>
          <div className={styles.wealthFieldsBox} data-aos="fade-up">
            <div className={styles.buyingChanceNumber}>1</div>
            <h5>Enter your budget</h5>
            <p>
              To get started, enter your budget into the Buying Chance
              Calculator. Our platform will then analyze the property market and
              provide you with a list of suburbs where you have the best chance
              of buying a property within your budget.
            </p>
          </div>

          <div className={styles.wealthFieldsBox} data-aos="fade-up">
            <div className={styles.buyingChanceNumber}>2</div>
            <h5>Choose your preferred suburb</h5>
            <p>
              Once you've received your list of suburbs, choose your preferred
              suburb from the list. Our platform will then provide you with a
              detailed report that includes clear insights into the property
              market, including median house prices, rental yields, and other
              key metrics.
            </p>
          </div>

          <div className={styles.wealthFieldsBox} data-aos="fade-up">
            <div className={styles.buyingChanceNumber}>3</div>
            <h5>Make informed investment decisions</h5>
            <p>
              With Buying Chance Calculator, you can make informed investment
              decisions based on your budget and preferred suburb. Our platform
              provides you with a comprehensive report that includes all the
              information you need to make a smart investment decision.
            </p>
          </div>
        </article>
      </section>
      <Footer />
    </>
  );
}
